// 日志管理
export default [{ // 登录日志
  path: '/loginLog',
  name: 'loginLog',
  component: resolve => require(['@/views/log/loginLog.vue'], resolve),
  meta: {
    group: "/loginLog",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 操作日志
  path: '/operationLog',
  name: 'operationLog',
  component: resolve => require(['@/views/log/operationLog.vue'], resolve),
  meta: {
    group: "/operationLog",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]



// WEBPACK FOOTER //
// ./src/router/log/log.js